/**
 * E-mail do suporte do app, lido do banco (`contacts`, `CONTATO_SUPORTE_APP_ID`) — GUPM-336.
 *
 * Quem mostra este e-mail é a tela de FALHA de carga — exatamente quando o banco pode
 * não responder (JWT vencido, rede fora). Por isso o último e-mail lido fica guardado
 * neste navegador e é devolvido enquanto a leitura falha. É a caixa institucional do
 * suporte, não dado pessoal; o banco segue sendo a fonte (trocou lá, troca aqui na
 * próxima leitura).
 */
import { useQuery } from '@tanstack/react-query';
import { useDataSources } from '@/services/datasources';
import { emailDeContato } from '@/domain/suporte';

const CHAVE = 'geoguard:email-suporte';

function lerGuardado(): string | null {
  try {
    return emailDeContato(localStorage.getItem(CHAVE));
  } catch {
    return null; // storage bloqueado (janela privada, política do navegador)
  }
}

function guardar(email: string | null): void {
  try {
    if (email) localStorage.setItem(CHAVE, email);
    else localStorage.removeItem(CHAVE);
  } catch {
    // Sem storage o e-mail só não sobrevive à próxima falha — a tela segue funcionando.
  }
}

export function useEmailSuporteApp(): string | null {
  const { contatos } = useDataSources();
  const { data } = useQuery({
    queryKey: ['contatos', 'suporte-app'],
    staleTime: 30 * 60 * 1000,
    queryFn: async () => {
      const email = emailDeContato(await contatos.getEmailSuporteApp());
      guardar(email);
      return email;
    },
  });
  return data !== undefined ? data : lerGuardado();
}
